export const initialState = () => ({
  isSameAddress: true,
  cep: "",
  address: "",
  number: "",
  noNumber: false,
  neighborhood: "",
  state: "",
  city: "",
  cityId: "",
  stateId: "",
  secondaryAddress: {
    type: "",
    text: "",
    value: ""
  }
})
